import CertScore from './Score.vue';

export default CertScore;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/score/index.ts